<template lang="pug">
v-dialog(v-model="modal",absolute,fullscreen,transition="slide-x-transition")
  div.expande-horizontal.centraliza.fonte.vitro(style="min-height: 100vh;").pa-2
    v-flex(xs12 md7 lg6)
      v-card.pa-6
        div(v-if="mode === 'error'")
          div.expande-horizontal.wrap
            v-flex(xs12).mb-2
              div.expande-horizontal.centraliza
                v-flex(xs6 md5)
                  LottieAnimation(
                    class="pa-0"
                    :animationData="require('@/apps/shared/assets/insumos.json')"
                  )
            v-flex(xs12).pb-4
              div.expande-horizontal.centraliza
                span.text-center(style="font-size: 27px;") Opa!
            v-flex(xs12).pb-12
              div.expande-horizontal.centraliza.column
                span.text-center.grey--text(style="max-width: 400px;") {{ error_message }}
            v-flex(xs12)
              div.expande-horizontal.centraliza.column
                v-btn.elevation-0.fonte.font-weight-bold.fonteMini(rounded :color="$theme.primary" dark @click="tryAgain") Revisar e tentar novamente!

        div(v-else-if="mode === 'pix'")
          v-flex(xs12)
            h2.text-center.mb-2 Finalize seu pagamento PIX
            p.text-center.grey--text.mb-4
              | Escaneie o QR Code abaixo ou copie o codigo PIX. A confirmacao e automatica nesta tela.

          v-flex(xs12).expande-horizontal.centraliza.mb-4
            v-card.qr-card(flat)
              v-img(v-if="qrImageSrc" :src="qrImageSrc" width="250" height="250" contain)
              div(v-else class="pa-8 text-center grey--text") QR Code indisponivel no momento

          v-flex(xs12).mb-3
            v-textarea(
              outlined
              readonly
              dense
              rows="4"
              label="PIX copia e cola"
              :value="pixPayload"
            )

          v-flex(xs12).expande-horizontal.wrap
            v-flex(xs12 md6).pa-1
              v-btn(block large outlined color="primary" @click="copyPixPayload")
                v-icon(left) mdi-content-copy
                | Copiar codigo PIX
            v-flex(xs12 md6).pa-1
              v-btn(block large :loading="checking" color="green" dark @click="checkNow")
                v-icon(left) mdi-refresh
                | Verificar pagamento

          v-flex(xs12).mt-3
            v-alert(type="info" dense text)
              | {{ pix_message }}

          v-flex(xs12).expande-horizontal.centraliza.mt-3
            v-btn(text color="grey darken-1" @click="tryAgain") Fechar
</template>

<script>
import { EventBus } from "@/main.js";
import LottieAnimation from "lottie-web-vue";

export default {
  data() {
    return {
      modal: false,
      mode: "error",
      error_message: "",
      checking: false,
      pixData: {
        subscriptionId: "",
        payment: {},
        pixQrCode: {}
      },
      pix_message: "Aguardando confirmacao do pagamento PIX...",
      pollingTimer: null
    };
  },
  components: {
    LottieAnimation
  },
  computed: {
    qrImageSrc() {
      const encoded = this.pixData?.pixQrCode?.encodedImage || "";
      if (!encoded) return "";
      if (encoded.startsWith("data:image")) return encoded;
      return `data:image/png;base64,${encoded}`;
    },
    pixPayload() {
      return this.pixData?.pixQrCode?.payload || "";
    }
  },
  methods: {
    tryAgain() {
      this.stopPolling();
      this.modal = false;
      this.checking = false;
      this.mode = "error";
      this.error_message = "";
      this.pix_message = "Aguardando confirmacao do pagamento PIX...";
      this.pixData = {
        subscriptionId: "",
        payment: {},
        pixQrCode: {}
      };
    },
    openPixModal(data) {
      this.modal = true;
      this.mode = "pix";
      this.checking = false;
      this.pixData = {
        ...this.pixData,
        ...data
      };
      this.pix_message = data?.message || "Pagamento PIX pendente. Aguardando confirmacao.";
      this.startPolling();
    },
    startPolling() {
      this.stopPolling();
      this.pollingTimer = setInterval(() => {
        this.checkNow();
      }, 5000);
    },
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    async checkNow() {
      if (this.checking || !this.pixData?.subscriptionId) {
        return;
      }

      this.checking = true;
      const result = await this.$store.dispatch("check_pix_payment", {
        subscriptionId: this.pixData.subscriptionId,
        email: this.$store.getters.get_checkout?.payer?.email
      });
      this.checking = false;

      if (!result) return;

      if (result.status === "paid") {
        this.stopPolling();
        this.modal = false;
        return;
      }

      if (result.status === "pending") {
        this.pixData = {
          ...this.pixData,
          ...result
        };
        this.pix_message = result?.message || "Pagamento PIX pendente. Aguardando confirmacao.";
      }
    },
    async copyPixPayload() {
      if (!this.pixPayload) return;
      try {
        await navigator.clipboard.writeText(this.pixPayload);
        this.$store.dispatch("createGlobalMessage", {
          type: "success",
          message: "Codigo PIX copiado com sucesso.",
          timeout: 3000
        });
      } catch (error) {
        this.$store.dispatch("createGlobalMessage", {
          type: "warning",
          message: "Nao foi possivel copiar automaticamente. Copie manualmente.",
          timeout: 4000
        });
      }
    }
  },
  created() {
    EventBus.$on("checkout-error", error => {
      this.stopPolling();
      this.modal = true;
      this.mode = "error";
      this.error_message = error;
    });

    EventBus.$on("checkout-pix-pending", data => {
      this.openPixModal(data || {});
    });
  },
  beforeDestroy() {
    this.stopPolling();
  }
};
</script>

<style scoped>
.qr-card {
  padding: 12px;
  border: 1px solid #dbe3ef;
  border-radius: 12px;
  background: #fff;
}
</style>
